import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsBoolean, IsEnum, IsInstance, IsOptional, ValidateNested } from 'class-validator';
import { PrepTimeCalculationRuleTypeEnum } from '../../order-config/enum';
import { OrderConfigExposeGroup } from '../../order-config/interface';
import { prepTimeCalculationByPriceRange } from '../../order-config/swagger';
import { ReadPrepTimeCalculationByPriceRangeDto } from './ReadPrepTimeCalculationByPriceRangeDto';
export class ReadPrepTimeCalculationByPriceRuleDto {
}
__decorate([
    ApiProperty({ type: () => Boolean, description: 'If true, the rule is enabled', example: true }),
    IsBoolean({ always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadPrepTimeCalculationByPriceRuleDto.prototype, "isEnabled", void 0);
__decorate([
    ApiProperty({ type: () => PrepTimeCalculationRuleTypeEnum.BY_PRICE }),
    IsEnum(PrepTimeCalculationRuleTypeEnum, { always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadPrepTimeCalculationByPriceRuleDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => ReadPrepTimeCalculationByPriceRangeDto, isArray: true, description: 'Price ranges', example: [prepTimeCalculationByPriceRange] }),
    Type(() => ReadPrepTimeCalculationByPriceRangeDto),
    ValidateNested({ each: true, always: true }),
    IsArray({ always: true }),
    ArrayNotEmpty({ always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH] }),
    IsInstance(ReadPrepTimeCalculationByPriceRangeDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], ReadPrepTimeCalculationByPriceRuleDto.prototype, "ranges", void 0);
//# sourceMappingURL=ReadPrepTimeCalculationByPriceRuleDto.js.map